export const TranslationsTR = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Endonezya',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
    },
    // BASE
    phrases: {
        order_online: 'Çevrimiçi Sipariş Ver',
        cart: 'Sepet',
        open_24: '24 Saat',
        closed: 'Kapalı',
        free: 'ÜCRETSİZ',
        something_went_wrong: 'bir şeyler ters gitti',
        try_again: 'tekrar deneyin',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Pazartesi',
                tuesday: 'Salı',
                wednesday: 'Çarşamba',
                thursday: 'perşembe',
                friday: 'Cuma',
                saturday: 'cumartesi',
                sunday: 'Pazar',
            },
        },
        services: {
            pickup: 'Teslim Alma',
            delivery: 'Teslimat',
            dine_in: 'Mekanda Yeme',
            table_booking: 'Masa Rezervasyonu',
        },
        payment: {
            method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Kredi kartı',
                paypal: 'PayPal',
                cardconnect: 'Kredi kartı',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Jilet Ödemesi',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Ödemesi',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora Asya Pasifik',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Kırmızı Nokta Ödemesi',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Ödemesi',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Cüzdan',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Ödemesi',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora Asya Pasifik',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Jilet Ödemesi',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Kırmızı Nokta Ödemesi',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Ödemesi',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Cüzdan',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Başarılı',
                pending: 'Beklemede',
                error: 'hata',
                refunded: 'İade Edildi',
                refunding: 'İade Ediliyor',
                partial_refunded: 'Kısmen İade Edildi',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Kaldır',
                drop_here: 'Dosyalarınızı buraya bırakın veya birini seçmek için tıklayın',
                accepts: '{{fileTypes}} bunları kabul eder',
                errors: {
                    max_files: 'İzin verilen maksimum {{number}}',
                    max_size: 'Maksimum dosya boyutu {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Mağaza şu anda kapalı ve hemen teslim edilmesi gereken bir yemek siparişi verilemiyor. Bunun yerine daha sonraki bir tarih ve saat için sipariş vermeyi deneyebilirsiniz',
            },
            buttons: {
                order: {
                    book_order: 'Masa Ayırın / Online Sipariş Verin',
                    order_online: 'Çevrimiçi Sipariş Ver',
                    book_table: 'Masa Ayırt',
                    order: 'Sipariş Ver',
                    book: 'Rezervasyon Yap',
                    cart: 'Sepet',
                    restart: 'Yeniden Başlat',
                    closed: 'Mağaza Kapalı',
                    not_accepting: 'Sipariş Kabul Edilmiyor',
                },
            },
        },
        modals: {
            auth: {
                login: 'Giriş Yap',
                register: 'Kayıt Ol',
                register_commence: 'Devam Et',
                register_complete: 'Hesap oluştur',
                register_confirmation_sent: 'E-posta adresinize onay kodu gönderildi. Devam etmek için lütfen aşağıya girin',
                register_confirmation_resent: 'Onay kodu tekrar gönderildi, spam\'inizi kontrol edin veya işlemi yeniden başlatın',
                register_restart: 'Yeniden Başlat',
                register_resend_code: 'Kodu yeniden gönder',
                register_confirmation_code_subject: 'E-Posta Onay Kodu',
                register_confirmation_code_email: 'E-posta onayını kodlamaz: {{confirmation_code}} (Süresi 24 saat içinde dolacaktır)',
                login_placeholder: 'E-posta',
                password_placeholder: 'Şifre',
                confirm_password_placeholder: 'Şifreyi Onayla',
                confirmation_code_placeholder: 'E-Posta Onay Kodu',
                accept_terms: 'Şartlar ve Koşulları kabul edin',
                accept_terms_view: 'Görüntüle',
                login_facebook: 'Facebook ile Giriş Yap',
                login_google: 'Google ile Giriş Yapın',
                benefits: 'Tüm siparişlerinizi kaydetmek için giriş yapın veya bir hesap oluşturun',
                logged_in: 'Başarıyla Giriş Yapıldı',
                logged_out: 'Çıkış Yapıldı',
                password_reset: {
                    init_button: 'Şifre Sıfırlama Postası Gönder',
                    init_success: 'Şifre sıfırlama bağlantısı e-postanıza gönderildi',
                    complete_button: 'Şifreyi Sıfırla',
                    complete_success: 'Şifreniz başarıyla sıfırlandı, yeni şifrenizle giriş yapın',
                    forgot_password_text: 'Şifrenizi mi unuttunuz?',
                    forgot_password_link: 'Şifreyi Sıfırla',
                    remember_password_text: 'Şifrenizi belirtemiyor musunuz?',
                    remember_password_link: 'Geri git',
                    invalid_title: 'Şifre Sıfırlama Geçersiz',
                    invalid_description: 'Bu şifre kesintisi bağlantısı mevcut değil, bunun yerine yenisini isteyin',
                    invalid_link: 'Giriş Yap’a Git',
                    title: 'Şifre Sıfırlama',
                    description: 'sistemi için yeni bir şifreyi girin',
                },
                error_generic: 'Bir şeyler ters gitti, lütfen tekrar deneyin veya bizimle iletişime geçin',
                error_accept_terms: 'Lütfen koşullar ve koşullar kabul edin',
                error_password_length: 'Şifre için minimum 6 karakter',
                error_social: 'Bir şeyler ters gitti, tekrar deneyin veya bizimle iletişime geçin',
                error_confirmation_code: 'Geçersiz onay kodu',
                error_invalid_code: 'Geçersiz onay kodu',
                error_exists: 'Kullanıcı zaten mevcut',
                error_invalid_email_pass: 'Geçersiz e-posta adresi veya şifre',
                error_password_no_match: 'Şifreler eşleşmiyor',
                error_user_not_found: 'Bu e-posta yöntemlerine sahip kullanıcı yok',
                error_invalid_email: 'Geçersiz e-posta adresi',
                error_invalid_reset_token: 'Geçersiz bağlantı bağlantısı, başka bir tane isteyin',
            },
            booking: {
                form: {
                    name: 'Reklam Soyadı',
                    email: 'E-Posta Adresi',
                    phone: 'Telefon Numarası',
                    number_of_people: 'Kişi Sayısı',
                    number_of_people_max: 'Kişi Sayısı ({{max_people}} Maks)',
                    number_of_people_min: 'Kişi Sayısı ({{min_people}} Min)',
                    number_of_people_max_min: 'Kişi Sayısı ({{min_people}} ile {{max_people}} Arasında)',
                    notes: 'Notlar / Özel İstekler',
                    submit: 'Rezervasyon Talebi Gönder',
                    email_optional: '(isteğe bağlı)',
                    date: 'Tarih',
                    duration: 'Süre',
                    seating: 'Uygun saatler',
                    number_of_guests: 'Misafir sayısı',
                    notes_placeholder: 'Alerjiler, özel gün, oturma tercihi',
                    reserving: 'Rezervasyon yapılıyor...',
                    reserve_table: 'Masa ayırt',
                    please_choose_a_date_and_time: 'Lütfen bir tarih ve saat seçin.',
                    invalid_people: 'Kişi sayısı {{min}} ile {{max}} arasında olmalıdır.',
                    party_size_max_fallback: 'izin verilen en fazla',
                    loading_available_times: 'Uygun saatler yükleniyor…',
                    select_a_date_to_see_available_times: 'Uygun saatleri görmek için bir tarih seçin.',
                    no_times_available_for_this_date: 'Bu tarih için uygun saat yok. Lütfen başka bir gün seçin.',
                    shift: 'Vardiya',
                    service_times: 'Servis saatleri',
                    new_shift: 'Yeni vardiya',
                    time: 'saat',
                    times: 'saat',
                    unavailable: 'Uygun değil',
                    available: 'Uygun',
                    required_name: 'Lütfen adınızı girin.',
                    required_phone: 'Lütfen telefon numaranızı girin.',
                    required_email: 'Lütfen e-posta adresinizi girin.',
                    invalid_email: 'Lütfen geçerli bir e-posta adresi girin.',
                    required_terms: 'Rezervasyon yapmadan önce şartları kabul edin.',
                    reservation_is_unavailable: 'Rezervasyon yapılamıyor.',
                    please_contact_the_restaurant_directly: 'Lütfen restoranla doğrudan iletişime geçin.',
                    almost_done: 'Neredeyse bitti',
                    your_details: 'Bilgileriniz',
                    tell_us_who_s_coming: 'Rezervasyonunuzu onaylayabilmemiz için kimin geleceğini söyleyin.',
                    book_your_table: 'Masanızı ayırtın',
                    choose_a_time_that_works_for_you: 'Size uyan bir saat seçin.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Rezervasyon talebinizi gönderin, gerisini restoran halletsin.',
                    select_date: 'Tarih seçin',
                    standard: 'Standart',
                    minutes: 'dakika',
                    next: 'İleri →',
                    back: '← Geri',
                    accept_terms: 'Şartlar ve koşulları kabul ediyorum.',
                    info_1: 'Rezervasyonunuzun kabul edilmesi veya reddedilmesi bir e-posta bildirimi değişiklikleri',
                },
                errors: {
                    not_found: 'Rezervasyon mevcut değil. muhtemelen silinmiş.',
                    generic: 'Bir şeyler ters gitti, programı yenileyin veya bizimle iletişime geçin',
                    something_went_wrong: 'Bir şeyler ters gitti',
                    accept_terms: 'Lütfen koşullar ve koşullar kabul edin',
                    required_phone: 'Lütfen telefon numaranızı girin',
                    required_email: 'Lütfen e-postanızı girin',
                    required_zip: 'Lütfen fatura posta kodunuzu girin',
                    required_name: 'Lütfen adınızı girin',
                    invalid_email: 'elbette bir e',
                    invalid_phone: 'Lütfen geçerli bir telefon numarasını girin',
                    invalid_people: 'Geçersiz kişi sayısı',
                    missing_custom_fields: 'Lütfen gerekli tüm alanları doldurun.',
                    booking_capacity_threshold: 'Bu saat için yerimiz dolu. Lütfen başka bir saat deneyin.',
                    slot_unavailable: 'Bu kişi sayısı için yerimiz dolu. Lütfen başka bir saat deneyin.',
                    booking_date_paused: 'Bu tarih için rezervasyonlar durduruldu. Lütfen başka bir gün seçin.',
                    invalid_table_assignment: 'Bu masalar grubunuzu ağırlayamaz. Lütfen başka bir saat seçin.',
                    exceeded_order_limit: 'Çok fazla rezervasyon talebi. Lütfen daha sonra tekrar deneyin.',
                    validation_failed_recaptcha_v3: 'Olağandışı trafik algılandı. VPN mi kullanıyorsunuz? Yukarıdaki doğrulamayı tamamlayıp tekrar deneyin.',
                    validation_failed_recaptcha_v2: 'Rezervasyon başlatılamadı. Lütfen tekrar deneyin veya başka bir yöntem kullanın. VPN kullanıyorsanız önce kapatmayı deneyin.',
                    booking_already_exists: 'Bu rezervasyon zaten gönderildi. E-postanızı kontrol edin veya rezervasyon bağlantınızı açın.',
                    invalid_party_size: 'Lütfen geçerli bir kişi sayısı seçin.',
                    invalid_request: 'Geçersiz istek. Lütfen sayfayı yenileyip tekrar deneyin.',
                    table_booking_unavailable: 'Masa rezervasyonu kullanılamıyor.',
                },
            },
            cart: {
                title: 'Sepet',
                proceed_to_checkout: 'Çıkışa doğru devam et',
                edit_dish: 'düzenlemek',
                remove_dish: 'Kaldır',
                no_items_1: 'Ürünü sepete atın',
                no_items_2: 'Devam etmek için önce biraz ekleyin',
                free_delivery_notice: '{{value, currency}} üzeri siparişlerde ücretsiz teslimat',
                errors: {
                    min_order_promo: 'Bu promosyonun değerinden önce yapılması gereken minimum sepet değeri {{value, currency}}',
                    min_order_delivery: 'teslimat için minimum sepet değeri {{value, currency}}',
                },
                promo: {
                    heading: 'Promosyon Kodu',
                    placeholder: 'Promosyon kodunuzu girin',
                    add: 'Kod Ekle',
                    title: 'Promosyon {{name}} sepetine eklendi',
                    fixed_discount: '{{value, currency}} Kapalı',
                    percent_discount: '{{value}}% İndirim',
                    added_to_cart: 'Promosyon sepetine eklendi',
                    errors: {
                        not_found: 'Promosyon başarısız oldu',
                        disabled: 'Promosyon devre dışı',
                        not_available: 'Promosyon şu anda mevcut değil',
                        not_eligible: 'Promosyon uygulamasını uygulamak uygun değil',
                        not_available_time: 'Promosyon bu sefer geçerli değil',
                        logged_in_only: 'Bu promosyonu kullanmak için giriş yapmalısınız',
                        already_used: 'Bu promosyonu zaten kullanmışsınız',
                        invalid: 'Bu promosyon artık geçerli değil',
                        invalid_service: 'Bu promosyonun hizmet için geçerli değil',
                        later_only: 'Yalnızca ön siparişlerde geçerlidir',
                        now_only: 'Ön siparişler için değil, yalnızca hemen teslim edilmesi gereken siparişler için geçerlidir',
                        generic: 'Hata... bir anma töreni gitti ve günlüğe kaydedildi',
                        dishes_required_multi: 'Bu promosyon yalnızca belirli ürünler stokunuza eklenecektir.',
                        dishes_required_single: "Bu promosyon yalnızca '{{dish}}' için uygulanacaktır",
                    },
                },
                tip: {
                    title: 'Sipariş İpucu',
                    placeholder: 'Sipariş ipucu ekleyin',
                },
            },
            free_items_promo: {
                title: 'Ücretsiz Öğeler',
                usage_confirmation: {
                    question: 'Ücretsiz verimlilikten yararlanma hakkı avantajları. Bunları görmek ve seçmek ister misiniz?',
                    cancellation: 'Hayır, ücretsiz ürün istemiyorum',
                    acceptance: 'Evet',
                },
                free_items_selection: {
                    multiple: {
                        description: '{{number}} ücretsiz öğeyi seç',
                    },
                    single: {
                        description: 'Ücretsiz bir öğe seçin',
                    },
                    confirm_button: 'Onayla',
                },
            },
            checkout: {
                title: 'Ödeme',
                subtitle: 'Sipariş detaylarınızı onaylayın',
                details: {
                    service: 'Hizmet',
                    due: 'Teslim Zamanı',
                    due_now_asap: 'Şimdi / En kısa sürede',
                    address: 'Teslimat Adresi',
                    total: 'Toplam',
                    table: 'Masa',
                    store_location: 'Mağaza Adresi',
                },
                customer: {
                    title: 'Müşteri',
                    subtitle: 'Siparişinizi ve ayrıntılarınızı düzenlemek için giriş yapın',
                    button: 'Giriş Yap',
                    name: 'Reklam Soyadı',
                    email: 'E-posta',
                    phone: 'telefon',
                    phone_important: 'Telefon (Önemli)',
                    notes: 'Sipariş Notları',
                    delivery_notes: 'Ödeme Talimatları / Sipariş Notları',
                    optional: 'genel bağlı',
                },
                payment: {
                    title: 'Ödeme yöntemi',
                    qr_modal_help: 'QR\'yi taramak ve bu siparişin ödemesini tamamlamak için {{app}} mobil uygulamanızı kullanın. Mobil uygulamanızda ödeme tamamlandıktan sonra bu QR yöntemini kapatabilirsiniz. Ödeme işleminizi tamamlamadıysanız lütfen bu QR modelini kapatmayın.',
                    switch_to_app_help: 'Aşağıdaki butona bastığınızda, bu siparişin ödemesini tamamlamak için {{app}} mobil uygulaması otomatik olarak açılacaktır. Mobil uygulamanızda ödeme tamamlandıktan sonra bu yöntemi kapatabilirsiniz. Ödeme işleminizi tamamlamadıysanız lütfen bu modeli kapatmayın.',
                    open_app: '{{app}} Aç',
                    continue: 'Devam Et',
                    continue_to_payment: "{{method}}'a devam et",
                    back_to_cart: 'Sepete Geri Dön',
                },
                accept_terms: 'Şartlar ve Koşulları kabul edin',
                accept_terms_view: 'Görüntüle',
                processing_order: 'Sipariş İşleniyor',
                warning: {
                    different_payment_currency: 'Mağaza fiyatları {{store_currency}} cinsindendir ancak ödeme yöntemi {{payment_currency}} cinsindendir',
                    closing_soon: 'Yakında kapanıyor, siparişlerin {{value}} dakika içindeki bilgiler gerekiyor',
                    closed: 'Üzgünüz, bu hizmet kapandı ve siparişler kabul edilmiyor',
                    paused: 'Üzgünüz, bu hizmet durduruldu ve şu an sonunda siparişler kabul edilmiyor',
                    expired: 'Artık siparişlerinizi saatte yerine getiremiyoruz. Lütfen daha sonraki bir tarih veya saati seçin',
                },
                errors: {
                    walletly_promo: 'Cüzdan promosyonunda hata var, lütfen başka bir promosyon hatası!',
                    stripe_generic: 'Kredi kartı hatası, tekrar hatalar veya başka bir yöntem',
                    validation_failed: 'Bu ödeme şu anda kabul edilemez. Lütfen daha sonra tekrar deneyin veya başka bir ödeme yöntemini seçin.',
                    validation_failed_recaptcha_v3: 'Olağandışı trafik algılandı. VPN kullanabiliyor musun? Lütfen mücadeleyi tamamlayın ve tekrar deneyin.',
                    validation_failed_recaptcha_v2: 'Ödemeyi başlatamadık. Lütfen tekrar deneyin veya başka bir yöntem kullanın. VPN kullanmadan önce onu kapatmayı hatası.',
                    stripe_loading_fail: 'Ödeme formülü yüklenirken hata oluştu, lütfen tekrar deneyin.',
                    something_went_wrong: 'Bir şeyler ters gitti',
                    paypal_generic: "PayPal'da bir sorun oluştu, tekrar deneyin veya başka bir ödeme yöntemi seçin",
                    payment_fail: 'Ödeme başarısız oldu, lütfen tekrar deneyin veya başka bir ödeme yöntemini seçin',
                    payment_cancelled: 'Ödeme iptal edildi, lütfen tekrar sorun veya başka bir ödeme yöntemi seçin',
                    payment_error: 'Çevrimiçi ödeme işleminde hata oluştu, tekrar sorun veya başka bir ödeme yöntemi seçin',
                    payment_declined: 'Ödeme yönteminiz reddedildi',
                    card_declined: 'Kartınız reddedildi ve ödeme işlemi yapılmadı',
                    promo_max_uses_exceeded: "Bu promosyon kodu kullanım sınırına ulaştı ve artık kullanılamaz.",
                    store_closed: 'Mağaza kapalı ve artık sipariş vermiyorsunuz kabul etmiyorsunuz',
                    accept_terms: 'Lütfen koşullar ve koşullar kabul edin',
                    required_payment: 'Lütfen bir ödeme yöntemini seçin',
                    required_phone: 'Lütfen telefon numaranızı girin',
                    required_email: 'Lütfen e-postanızı girin',
                    required_zip: 'Lütfen fatura posta kodunuzu girin',
                    required_name: 'Lütfen adınızı girin',
                    invalid_email: 'elbette bir e',
                    invalid_phone: 'Lütfen geçerli bir telefon numarasını girin',
                    invalid_cc_number: 'Kredi kartı numaranız geçersiz',
                    invalid_order_amount: 'Bu ödeme yöntemi için yapılması gereken minimum tutar',
                    retry_cc_number: 'Bir şeyler ters gitti, kredi kartı numaranızı tekrar girin ve tekrar deneyin',
                    closed: 'Mağaza kapalı ve sipariş vermiyor',
                    promo_login_required: 'Bu promosyonu kullanmak için giriş yapmalısınız',
                    promo_used: 'Bu promosyonu zaten kullanmışsınız',
                    promo_by_payment_method_not_applicable: 'Promosyon seçilen ödeme yönteminde geçerli değildir.',
                    missing_custom_checkout_fields: 'Lütfen gerekli tüm alanları doldurun.',
                    delivery_unavailable: 'Şu anda teslimat hizmeti mevcut olmayabilir. Lütfen bunun yerine Teslim Alma siparişi vermeyi düşünün.',
                    required_delivery_provider: 'Lütfen bir hizmet sunumu yapın.',
                    required_delivery_quotation: 'Tahmininin süresi doldu.',
                    exceeded_order_limit: 'Şu anda çok fazla sipariş alımı. Lütfen daha sonraki bir zamanı seçin.',
                    exceeded_order_limit_later: 'Artık siparişlerinizi saatte yerine getiremiyoruz. Lütfen daha sonraki bir tarih veya saati seçin',
                },
                button: {
                    continue: 'Ödemeye Devam Et',
                    place_order: 'Sipariş Ver',
                    update_order: 'Siparişi Güncelle',
                },
                delivery_estimation: {
                    title: 'Satış Tahmini',
                    details: {
                        provider: 'Dağıtım Sağlayıcı',
                        estimated_fee: 'Tahmin Ücreti',
                        estimated_total_fee: 'Ücret Ücreti Toplam',
                        estimated_discount_fee: 'Fiyat Ücreti İndirimi',
                        previous_estimated_fee: 'Önceki Tahmin Ücreti',
                        tips: 'Bahşiş',
                        estimated_delivery_time: 'Tahmini Süre Süresi',
                        uber_new_estimation: 'Yeni tahmin isteyin',
                        uber_new_estimation_success: 'Yeni Uber Tahminin dağıtılması.',
                        uber_estimation_expired: 'sarfiyat tahmininin süresi doldu',
                        uber_price: 'Uber fiyatını koruyoruz',
                        uber_need_time: 'Daha fazla zamana ihtiyaç var',
                        lalamove_price: 'Lalamove teslimat ücretini sürdüğünüz',
                        lalamove_new_estimation_success: 'Yeni Lalalmove teslimatlarını tahmin etmek.',
                        lalamove_estimation_expired: 'sarfiyat tahmininin süresi doldu',
                        lalamove_need_time: 'Daha fazla zamana ihtiyaç var',
                        lalamove_new_estimation: 'Yeni tahmin isteyin',
                    },
                    quotation_error: 'Tahmini tahminler yapılırken bir şeyler ters gitti.',
                },
            },
            customer: {
                age_v: {
                    title: 'Yaş Doğrulaması',
                    required_for_items: 'bileşenlerini sipariş etmek için gerekli',
                    min_age: 'Minimum yaş: {{age}} yıl',
                    est_time: 'Tahmini işleme süresi: {{time}} saat',
                    upload_description: 'Doğrulama için kimliğinizi aşağıya yükleyin. Doğrulandıktan sonra e-posta yoluyla bilgilendirileceksiniz. Her biri maksimum 2 MB boyutunda en fazla 2 resim yükleyin',
                    pending_description_1: 'Belgelerinizi gönderdiğiniz için teşekkür ederiz. Onaylandığınızda e-posta yoluyla bilgilendirileceksiniz',
                    pending_description_2: 'Doğrulama durumunuzu güncellemek için sayfayı yenileyin. Tahmini doğrulama süresi {{time}} saattir',
                    approved_description: 'bileşenleri doğrulanmış ve sınırlı menülerden sipariş verebilirsiniz',
                    rejected_description: 'Kimliğiniz reddedildi. Tekrar deneyin isterseniz lütfen kimliğinizi yeniden yükleyin',
                    upload: 'Yükle',
                    reupload: 'Belgeleri Yeniden Yükle',
                    go_back: 'Geri git',
                    view_document: 'Belgeyi Görüntüle {{number}}',
                    status: {
                        unverified: 'Doğrulanmamış',
                        pending: 'Onay Bekleniyor',
                        approved: 'Başarıyla Doğrulandı',
                        rejected: 'Reddedildi',
                    },
                },
                headings: {
                    sessions: 'Oturumlar',
                    orders: 'Sipariş',
                    spend: 'Harcama',
                    order_history: 'Sipariş Geçmişi',
                    loyalty: 'Sadaka',
                    loyalty_points: 'Sadakat Puanları',
                    added: 'Promosyon eklendi.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Lütfen kullanmadan önce herhangi bir öğeyi seçin!',
                    not_found: 'Promosyon başarısız oldu!',
                    already_exists: 'Promosyon zaten mevcut!',
                    try_again: 'Bu anlaşma uygulanamıyor. Lütfen tekrar deneyin!',
                },
            },
            custom_payment: {
                title: '{{name}} Ödeme Formu',
                description: 'Online ödeme formumuza ulaştınız. Ödeme yapmak için lütfen aşağıdaki alanları doldurunuz. Tutar girilmezse bilgileriniz kaydedilecek ancak sizden herhangi bir ücret alınmayacaktır.',
                disabled: 'Bu çevrimiçi ödeme sayfası doğru şekilde yapılandırılmamış. Sorunun düzeltilmesi için lütfen site sahibiyle iletişime geçin.',
                success: 'Ödemeniz başarıyla işlendi ve imzalandız kaydedildi. Teşekkür ederim',
                back: 'Ana Sayfaya Geri Dön',
                fields: {
                    name: 'Reklam Soyadı',
                    email: 'E-posta Adresi',
                    reference: 'Ödeme Ref.',
                    amount: 'Tutar ($)',
                    name_on_card: 'Karttaki İsim',
                    submit: 'Ödemeyi Gönder',
                },
                warning: {
                    currency: 'Not: Ödeme bölünmüş {{actual}} olarak değil, {{default}} olarak değil',
                },
                errors: {
                    generic: 'Bir şeyler ters gitti, tekrar deneyin veya bizimle iletişime geçin',
                    stripe_generic: 'Kredi kartı hatası, kodu yenileyip tekrar hatası',
                    payment_fail: 'Ödeme başarısız oldu, lütfen tekrar deneyin veya başka bir ödeme yöntemini seçin',
                    payment_cancelled: 'Ödeme iptal edildi, lütfen tekrar sorun veya başka bir ödeme yöntemi seçin',
                    payment_error: 'Çevrimiçi ödeme işleminde hata oluştu, tekrar sorun veya başka bir ödeme yöntemi seçin',
                    payment_declined: 'Ödeme yönteminiz reddedildi',
                    card_declined: 'Kartınız reddedildi ve ödeme işlemi yapılmadı',
                    promo_max_uses_exceeded: "Bu promosyon kodu kullanım sınırına ulaştı ve artık kullanılamaz.",
                },
            },
            dish: {
                add: 'Sepete ekle',
                edit: 'Öğeyi Güncelle',
                notes: 'Özel talimatlar...',
                ingredients: {
                    title: 'Malzemeler',
                    uncheck_remove: 'Kaldırmak için işaretinin devam etmesi',
                },
                ingredients_title: 'Malzemeler',
                combo: {
                    choose_dish: 'Bir Ürün Seçin',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Birini seç (Gerekli)',
                        select_one_optional: 'Birini seçin (İsteğe bağlı)',
                        select_between: '{{min}} - {{max}} arasında seçim yapın (Gerekli)',
                        select_at_least: 'En az {{qty}} seç (Gerekli)',
                        select_up_to: "{{qty}}'a kadar seç (İsteğe bağlı)",
                        select_multiple_optional: 'Birden fazla seç (İsteğe bağlı)',
                        select_multiple: 'Birden fazla seç (Gerekli)',
                        free_amount: 'İlk {{qty}} Ücretsiz / {{selected}} seçildi',
                    },
                    points: {
                        none_consumed: 'Ücretsiz olarak maksimum {{maxFree}} seçeneği',
                        less_than_total_points: 'Ücretsiz olarak daha fazla seçenek seçeneği',
                        greather_than_total_points: 'Ek ücret karşılığında daha fazla seçenek seçeneği',
                    },
                },
                error: 'Lütfen kırmızıyla işaretlenmiş çözümleri düzeltin',
                added_to_cart: 'Ürün Sepete Eklendi',
            },
            map: {
                zone_fee: 'Fiyat Ücreti',
                view_in_google: 'Google Haritalar’da Görüntüle',
            },
            portal_go_back: {
                title: 'Restoran Aramaya Geri Dönülsün mü?',
                description: 'Sepetinizdeki tüm ürünler kaybolacak',
                cancel: 'İptal',
                proceed: 'Geri git',
            },
            order: {
                config: {
                    services: {
                        title: 'Bir Hizmet Seçin',
                        table_booking: 'Kitap Masası',
                    },
                    address_custom: {
                        input_placeholder: 'Adresinizi girin',
                    },
                    address: {
                        input_placeholder: 'Teslimat Adresinizi Bulun',
                        extras_placeholder: 'Ünite numarası, bina adı, teslimat talimatları vb.',
                        search_placeholder: 'Adresinizi Arayın',
                        search_input_placeholder: 'Aramak için yazın',
                        no_address_found: 'Adres bulunamadı. 5\'ten fazla karakter yazma hatası',
                        not_found: 'arıza adresi hatalı veya geçerli değil, tekrar sorun',
                        not_delivering: 'Şu anda bu adrese teslimat yapmıyoruz',
                        not_in_range: 'Adresiniz mağazamızın konumunu kapsamaktadır',
                        not_in_zone: 'Adresiniz aktif bir teslimat bölgesi değil',
                        no_number: 'Adresinizin bir sokak numarası olmalıdır',
                        location_permission: 'Bu web parçalarının mevcut bilgilerine izin vermenize izin verelim mi?',
                        location_permission_warning: 'Mevcut konumunuza erişilemiyor. Lütfen cihazınızda ve web tarayıcınızda konum hizmetini etkinleştirin. İşte bazı referanslar:',
                        pick_location: 'Konumunuzu Seçin',
                        pick_location_help_text: 'Haritadaki konumu seçmek için araçları sürükleyin.',
                        use_current_location: 'Mevcut Konumu Kullan',
                        locate_on_map: 'Haritada Bulundu',
                    },
                    datetime: {
                        title: 'Siparişinizi Ne Zaman İstiyorsunuz?',
                        due_now: 'Şimdi',
                        due_later: 'Daha Sonra',
                        service_not_available: 'Üzgünüz, şu anda {{service}} için sipariş kabul etmiyoruz',
                        currently_closed: '{{service}} şu anda kapalı ancak daha sonra sipariş verebilirsiniz',
                        due_unavailable: 'Müsait Değil',
                        due_closed: 'Kapalı',
                        select_date: 'Tarih Seçin',
                        select_time: 'Zamanı Seçin',
                        select_order_date: 'Sipariş Tarihinizi Seçin',
                        select_order_time: 'Sipariş Zamanınızı Seçin',
                        select_order_date_time: 'Sipariş Tarihinizi/Saatinizi Seçin',
                        select_booking_date: 'Rezervasyon Tarihinizi Seçin',
                        select_booking_time: 'Rezervasyon Zamanınızı Seçin',
                        no_times_available: 'Herkesin seçim yapabileceği zaman yok',
                        date_today: '(Bugün)',
                        date_closed: '(Kapalı)',
                        date_bookings_paused: '(Rezervasyonlar durduruldu)',
                        time_slot_closed: 'Kapalı',
                    },
                    number_of_people: {
                        placeholder: 'Kişi Sayısı',
                    },
                    table: {
                        select: 'Tablo Seç',
                        select_popup_title: 'Masanızı Seçin',
                        password: 'Tablo Şifresi',
                        password_warning: 'Devam etmek için şifrenizi girin',
                    },
                    warning: {
                        closed: 'Üzgünüz, şu anda kapalıyız/sipariş kabul etmiyoruz',
                        not_available: 'Üzgünüz, şu anda herhangi bir siparişi kabul etmiyoruz',
                    },
                    eta: {
                        delivery: `Tahmini teslimat süresi yaklaşık {{minutesToCustomer}} dakikadır`,
                        pickup: `Sipariş yaklaşık {{minutesToCustomer}} dakika içinde hazır olacak`,
                    },
                    start_button: 'Siparişi Başlat',
                },
                history: {
                    invalid: 'Sipariş edilen ürünlerden bazıları değiştirildiğinden veya artık mevcut olmadığından yeniden sipariş verilemez',
                },
                reorder: {
                    title: 'Hızlı Yeniden Sipariş',
                    description: 'Önceki siparişlerinizde yer alan ürünleri kolayca sipariş edin',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Sipariş başarısız oldu, arızayı yenileyip tekrar hatası',
                    booking_not_found: 'Rezervasyon mevcut değil. Silinmiş olabilir',
                    generic: 'Bir şeyler ters gitti, programı yenileyin veya bizimle iletişime geçin',
                },
                connection: {
                    connected: 'Gerçek zamanlı güncellemeler',
                    connecting: 'Gerçek zamanlı güncellemeler bağlanıyor',
                    disconnected: 'Gerçek zamanlı kesintilerin bağlantısı kesildi',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Uyarı',
                    title: 'Çıkış Yap',
                    body: 'Oturumu kapatacak, paketinizi dolduracak tüm ürünleri kaldıracak',
                    cancel: 'İptal',
                    proceed: 'Devam Et',
                },
                order_restart: {
                    warning: 'Uyarı',
                    title: 'Sipariş Ayrıntılarını Değiştir',
                    body: 'Sipariş ayrıntılarınızı değiştirebilirsiniz, belirli ürünleri kullanamayabileceğinizden stokunuzdaki ürünleri kaldıracaktır',
                    cancel: 'İptal',
                    proceed: 'Devam Et',
                },
                order_expired: {
                    subtitle: 'Önemli',
                    title: 'Siparişin teslimi değiştirilecek şekilde değiştirildi',
                    description: 'Siparişiniz için seçilen saat artık çok uzakta değil. Bu nedenle siparişiniz derhal / En kısa sürede teslim edilecek şekilde değiştirildi',
                    button: 'tamam',
                },
                order_expiring: {
                    subtitle: 'Önemli',
                    title: 'Sipariş Son Tarihi Yakında Sona Eriyor',
                    description: 'Siparişiniz {{time, timeFromTimestamp}} önce değişir, aksi takdirde siparişiniz artık geçerli olmayacaktır',
                    button: 'tamam',
                },
                location_permission: {
                    cancel: 'İptal',
                    proceed: 'Devam Et',
                },
            },
            card_payment_authentication: {
                title: 'Ödeme Kimlik Doğrulaması',
                note: 'Lütfen bankanızdan kimlik doğrulama sürecini kurtarana kadar bu pencereyi açık tutun.',
            },
            maps: {
                cancel: 'İptal',
                use_location: 'Konumu Kullan',
            },
            app_refresh: {
                refresh: 'Yenile',
                title: 'Mağazayı Yenile',
                description: 'Mağazamız yenilenmiştir. En son sürüme erişmek için lütfen tarayıcınızı yenileyin. Yenilemenin ardından ödeme işlemine devam etmek için sepetinizi yeniden açmanız gerekebilir.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Misafir',
                login: 'Giriş Yap',
                login_signup: 'Giriş / Kayıt Ol',
                logout: 'Çıkış Yap',
            },
            menus: {
                info: {
                    no_menus: 'Şu anda mevcut menü yok',
                    restrictions: 'Menü Kısıtlamaları',
                    not_available: 'Menü Mevcut Değil',
                    unavailable: {
                        times: 'Menü mevcut değil, siparişleriniz aşağıdakilerle eşleşmiyor',
                        services: 'Menü mevcut değil, siparişleriniz aşağıdakilerle eşleşmiyor',
                        hours: 'Menü mevcut değil, sipariş ayarlarız bu menünün mevcut olduğu saatler dahil değil',
                        pre_order: 'Menü mevcut değil, siparişiniz ön siparişlerle eşleşmiyor',
                        age: 'Menü kullanılamıyor, bu menüden sipariş vermek için yaşı doğrulanmış bir hesapla oturum açmalısınız',
                    },
                    services: {
                        title: 'Sipariş Gereksinimleri',
                        pickup: 'Teslim Alımlar',
                        delivery: 'teslimatlar',
                        dine_in: 'Mekanda Yemeler',
                    },
                    times: {
                        now: 'Ön sipariş yok',
                        later: 'Yalnızca ön siparişler',
                    },
                    hours: {
                        title: 'Müsait Saatler',
                    },
                    preorder: {
                        title: 'Ön Sipariş Gereksinimleri',
                        days_in_advance: '{{days}} gün önceden sipariş verildi',
                        cutoff_time: 'Son günün tarih saati: {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Yaş Sınırlı',
                        approved: 'veri dosyası doğrulandı ve bu menüden sipariş verebilirsiniz',
                        rejected: 'Sipariş vermek için yaşlanması gerekir. Bir hesap bilgilerinizi ve kimliğinizi girin',
                    },
                },
                search: {
                    title: 'Menü Öğelerini Keşfedin',
                    no_result: 'Hiçbir şey geri dönmedi. Başka bir arama terimini denemek ister misiniz?',
                    placeholder: 'Ne çıkacak?',
                },
            },
            category: {
                restrictions: 'Kategori Kısıtlamaları',
                not_available: 'Kategori Mevcut Değil',
                unavailable: {
                    services: 'Kategori mevcut değil, siparişleriniz aşağıdakilerle eşleşmiyor',
                    hours: 'Kategori mevcut değil, sipariş seçeneklerini seçmiyorsunuz bu kategorinin uygun saatleri değil',
                },
            },
            info: {
                location: {
                    title: 'Konum',
                    view_map: 'Haritayı Görüntüle',
                    phone: 'telefon',
                },
                hours: {
                    title: 'Açılış Saatleri',
                    title_special: 'Özel Açılış Saatleri',
                },
                services: {
                    title: 'Hizmetler',
                    notes: 'Notlar',
                    delivery: {
                        ranges: 'Dağıtım Aralıkları',
                        zones: 'Dağıtım Bölgeleri',
                        view_zones: 'Bölgeleri Haritada Görüntüle',
                        fee: 'Fiyat Ücreti',
                        fee_short: 'Ücret',
                        fee_varies: 'Değişir, sepette gösterilir',
                        min_order: 'Minimum Sipariş',
                        min_order_short: 'Min. sip.',
                        no_min_order: 'Minimum Sipariş Yok',
                        free_amount: 'Ücretsiz Dağıtım Tutarı',
                    },
                },
            },
            contact: {
                title: 'Bize Ulaşın',
                name: 'Reklam Soyadı',
                email: 'E-posta',
                phone: 'Telefon Numarası',
                message: 'Mesajınızı girin...',
                send: 'Mesaj Gönder',
                success: 'Mesajınız başarıyla gönderildi',
                error: 'Bir şeyler ters gitti, tekrar sorun veya daha sonra hata',
            },
            footer: {
                powered_by: 'Tarafından desteklenmektedir',
                terms_and_conditions: 'Şartlar ve Koşullar',
                privacy: 'Gizlilik Politikası',
                cookie: 'Çerez Politikası',
            },
        },
        pages: {
            payment_completed: {
                title: 'Ödemeniz işlendi. Siparişiniz için teşekkür ederiz!',
                subtitle: 'Sipariş alımız e-posta adresinize gönderilmiştir.',
                back_to_menu: 'Menüye Geri Dön',
                close_tab: 'Bu sekmeyi kapat',
            },
            payment_failed: {
                title: 'Maalesef ödemeniz işlenirken bir hata oluştu.',
                subtitle: '',
                back_to_menu: 'Menüye Geri Dön',
                close_tab: 'Bu sekmeyi kapat',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Rezervasyon Makbuzu',
            details: {
                datetime: 'Rezervasyon',
                number_of_people: 'Kişi Sayısı',
                placed: 'oluşturuldu',
                updated: 'Son Güncelleme',
                notes: 'Notlar',
                name: 'Reklam Soyadı',
                email: 'E-posta',
                phone: 'telefon',
                store_address: 'Mağaza Adresi',
            },
            status_update: {
                title: 'Rezervasyon {{number}} Güncellendi',
                body: 'Rezervasyonun yapılması {{status}} olarak güncellendi',
            },
            email_common: {
                name: 'İsim: {{name}}',
                phone: 'Telefon: {{number}}',
                number_of_people: 'Kişi Sayısı: {{number}}',
                date: 'Tarih: {{date}}',
                time: 'Zaman: {{time}}',
                location: 'Mağaza Konumu: {{name}}',
                notes: 'Notlar: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Yeni Masa Rezervasyonu {{number}} Yazan: {{name}}',
                powered_by: '{{name}} tarafından desteklenmektedir',
                overview: 'Yeni Masa Rezervasyon Talebi',
                title: '{{name}} İçin Yeni Rezervasyon',
                subtitle: 'Rezervasyon Numarası {{number}}',
                description_confirmed: 'Rezervasyon otomatik olarak onaylandı. Yönetici kontrol panelinden iptal edebilirsiniz; müşteriniz e-postayla bilgilendirilecektir',
                description_unconfirmed: 'Lütfen bulunduğunuz yönetici kontrol panelinden onaylayın veya iptal edin',
                url_pre_text: 'Şu adresin görüntülenmesi ve güncellenmesi:',
            },
            email_new_booking_customer: {
                subject: 'Masa Rezervasyon Talebi',
                powered_by: '{{name}} tarafından desteklenmektedir',
                overview: 'Yeni Masa Rezervasyon Talebi',
                title: 'Rezervasyonunuz İçin Teşekkürler Ederiz',
                subtitle: 'Rezervasyon Numarası {{number}}',
                description: '<b>Rezervasyonunuz onaylandığında veya reddedildiğinde başka bir e-posta alacaksınız.</b><br>Rezervasyonunuzda değişiklik yapmak için lütfen bizimle iletişime geçin. Rezervasyonunuzun detayları aşağıdaki gibidir:',
                url_pre_text: 'Gerçek zamanlı rezervasyon makbuzunuzu şu adreste görüntüleyebilirsiniz:',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Masa Rezervasyonu Onaylandı',
                subject_unconfirmed: 'Masa Rezervasyonu İptal Edildi',
                powered_by: '{{name}} tarafından desteklenmektedir',
                overview: 'Masa Rezervasyon Talebi',
                title_confirmed: 'Rezervasyon Onaylandı',
                title_unconfirmed: 'Rezervasyon İptal Edildi',
                subtitle: 'Rezervasyon Numarası {{number}}',
                description_confirmed: 'Sizi görmeyi sabırsızlıkla bekliyoruz. Rezervasyonunuzda herhangi bir değişiklik talebiniz için lütfen bizimle iletişime geçin.',
                description_unconfirmed: 'Rezervasyon talebinizin kabul edilemediğini üzülerek bildiririz. Verdiğimiz rahatsızlıktan dolayı özür dileriz. Herhangi bir sorunuz varsa lütfen bizimle iletişime geçin',
                url_pre_text: 'Gerçek zamanlı rezervasyon makbuzunuzu şu adreste görüntüleyebilirsiniz:',
            },
            email_status_update_customer: {
                subject: 'Rezervasyon #{{number}} – {{subjectLabel}}',
                body: '{{store}} rezervasyonunuz #{{number}} artık {{status}}.',
            },
            errors: {},
            status_warning: 'Bu yazılanların, rezervasyon sayfalarındaki yönetici kontrol panelinizde güncelleyin',
        },
    },
    email_delayed_order: {
        subject: 'Sipariş #{{number}} – {{subjectLabel}}',
        header: 'Güncellenen hazır olma saati',
        title: 'Güncellenen hazır olma saati',
        order_number: 'Sipariş Numarası: {{number}}',
        description: 'Siparişiniz artık {{time}} saatinde hazır olacak.',
        order_time_updated_to: 'Sipariş saatiniz güncellendi.',
        powered_by: '{{name}} tarafından desteklenmektedir',
        button_text: 'Siparişi Takip Et',
        subject_label: 'Güncellenen hazır olma saati',
        subject_label_delivery: 'Güncellenen teslimat saati',
        body_ready: 'Siparişiniz artık {{time}} saatinde hazır olacak.',
        body_delivery: 'Siparişiniz artık {{time}} saatinde teslim edilecek.',
    },
    order: {
        receipt: {
            est_ready_time: 'Avustralya, Brezilya ve Kuzey Amerika ülkelerinin kullandığı saat uygulaması. Hazır Zaman',
            est_driver_pickup_time: 'Avustralya, Brezilya ve Kuzey Amerika ülkelerinin kullandığı saat uygulaması. Sürücü Alış Saati',
            est_delivery_time: 'Avustralya, Brezilya ve Kuzey Amerika ülkelerinin kullandığı saat uygulaması. dağıtım süresi',
            tab_details: 'Detaylar',
            tab_dishes: 'Ürünler',
            future_order: 'Gelecek Sipariş',
            reprint: 'YENİDEN YAZDIR',
            details: {
                order_no: 'Sipariş No.',
                status: 'Durum',
                placed: 'oluşturuldu',
                due: 'Teslim Zamanı',
                due_asap: 'Şimdi / En kısa sürede',
                last_updated: 'Son Güncelleme',
                total: 'Toplam',
                type: 'Tür',
                origin: 'kaynak',
                table: 'Masa',
                number_of_people: 'Kişi Sayısı',
                payment_method: 'Ödeme yöntemi',
                payment_status: 'Ödeme Durumu',
                payment_currency: 'Ödeme Para Birimi',
                notes: 'Notlar',
                name: 'Reklam Soyadı',
                email: 'E-posta',
                phone: 'telefon',
                distance: 'Mesafe',
                driving_time: 'Harcama Süresi',
                delivery_zone: 'Bölge',
                delivery_address: 'Teslimat Adresi',
                delivery_provider: 'Dağıtım Sağlayıcı',
                delivery_tracking: 'Teslimat Takibi',
                delivery_return_tracking: 'İadeyi Takip Et',
                delivery_tracking_link: 'Siparişi Takip Et',
                tookan_status: 'Tookan Durumu',
                tookan_status_failed_book: 'kesintileri yapılamadı',
                tookan_status_failed_update: 'Rezervasyon güncellenemedi',
                tookan_status_success: 'satış için rezervasyon yapıldı',
                store_address: 'Mağaza Adresi',
                destination: 'Varış Noktası',
                estimated_arrival_time: 'Tahmini Varış Zamanı',
                delivery_status: 'Durum',
                delivery_track_your_order: 'Siparişinizi Takip Edin',
                delivery_text: 'teslimat',
                arrival_date: 'Varış Tarihi',
            },
            dishes: {
                headings: {
                    quantity: 'Adet',
                    item: 'Ürün',
                    price: 'Fiyat',
                },
                notes: 'Notlar',
                remove_ingredients: 'Malzemeleri Kaldır',
            },
            status_update: {
                title: 'Sipariş {{number}} Güncellendi',
                body: 'Siparişin düzeni {{status}} olarak güncellendi',
            },
            wait_time_update: {
                title: 'Sipariş {{number}} Güncellendi',
                body: 'Siparişinizin son teslim tarihi güncellendi',
            },
            delivery_update: {
                title: 'Sipariş {{number}} Güncellendi',
                body: 'Siparişinizin teslimatı için rezervasyon yaptırılmıştır. Gerçek zamanlı izleme görüntüleri',
            },
            payment_status_update: {
                title: 'Sipariş {{number}} Güncellendi',
                body: 'Sipariş ödemesi güncellendi.',
            },
            email_new_order_restaurant: {
                subject: 'Yeni Sipariş ({{number}}) - {{name}}',
                powered_by: '{{name}} tarafından desteklenmektedir',
                overview: 'Yeni Sipariş Bildirimi',
                title: '{{name}} Tarihinde Yeni Sipariş Verildi',
                subtitle: 'Sipariş Numarası {{number}}',
                description: 'Ayrıntıları ve güncellemeleri idari kontrol panelinizden görüntüleyebilirsiniz',
                button_text: 'Siparişi Takip Et',
                track_delivery_button_text: 'teslimatı Takip Et',
            },
            email_new_order_customer: {
                subject: 'Sipariş Makbuzu ({{number}})',
                powered_by: '{{name}} tarafından desteklenmektedir',
                overview: 'Yeni Sipariş Bildirimi',
                title: '{{name}} Tarihinde Yeni Sipariş Verildi',
                subtitle: 'Sipariş Numarası {{number}}',
                description: 'Ayrıntıları ve güncellemeleri gerçek zamanlı çevrimiçi makbuzunuzla görüntüleyebilirsiniz',
                button_text: 'Siparişi Takip Et',
                track_delivery_button_text: 'teslimatı Takip Et',
            },
            email_order_completed_by_customer: {
                subject: 'Sipariş ({{number}}) Müşteri Tarafından Tamamlandı',
                powered_by: '{{name}} tarafından desteklenmektedir',
                overview: 'Sipariş Tamamlandı Bildirimi',
                title: 'Sipariş {{name}} Tarihinde Tamamlandı',
                subtitle: 'Sipariş Numarası {{number}}',
                description: 'Kontrol paneliniz aracılığıyla veya bulunduğunuz yerdeki makbuzu kullanarak ayrıntıları görüntüleyin ve siparişinizi güncelleyin.',
            },
        },
        totals: {
            tax: '{{name}} (%{{percent}})',
            tax_in_prices: '{{name}} (%{{percent}}) dahil. fiyat',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} (%{{percent}})',
            fee_fixed: '{{name}}',
            delivery_fee: 'Fiyat Ücreti',
            delivery_fee_offset: 'Fiyat Ücreti İndirimi',
            delivery_fee_total: 'Ücret Ücreti Toplam',
            promo: 'İndirim: {{name}} ({{value, currency}} + {{percent}}% İndirim)',
            promo_percent: 'İndirim: {{name}} ({{percent}}%)',
            promo_fixed: 'İndirim: {{name}}',
            promo_none: 'İndirim: {{name}}',
            cart: 'Sepet',
            tip: 'Sipariş ipucu',
            total: 'Toplam',
        },
        status: {
            unconfirmed: 'Onaylanmadı',
            awaiting_payment: 'Ödeme Bekleniyor',
            confirmed: 'Onaylandı',
            ready: 'Hazır',
            on_route: 'Rotada',
            complete: 'Tamamlandı',
            cancelled: 'İptal Edildi',
            seated: 'Oturtuldu',
        },
        searching: {
            lalamove_search_placeholder: 'Siparişi Lalamove teslimat varlığına göre arayın',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Müsait Değil',
                },
            },
            dish: {
                no_stock: 'Stoklar tükendi',
                not_available: 'Müsait değil',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'E-Posta Onay Kodu',
            register_confirmation_code_email: 'E-posta onayını kodlamaz: {{confirmation_code}} (Süresi 24 saat içinde dolacaktır)',
            register_confirmation_code_email_onbehalf: 'E-posta onay kodunuz: {{confirmation_code}} (Süresi 24 saat içinde dolacaktır). Bu, {{email}} e-posta adresi içindir.',
        },
    },
};
//# sourceMappingURL=tr.js.map